import "antd/dist/antd.css"
import React from "react"
import {Body} from "../../../components/Body"
import Theme from "../theme"

// TODO: Separate the wrap UI for TravelersBar and UserBar

const Layout = (props) => {
  return (
    <Body
      footerRenderer={props.footerRenderer}
      hasBoundary
      hasHeader
      headerLinks={props.headerLinks}
      theme={Theme}
      title="Cost Projection"
      titleLink="cost-projection"
    >
      {props.children}
    </Body>
  )
}

export {Layout}
